import{getFabricWindow as n}from"../../env/index.min.mjs";function e(e){return n().requestAnimationFrame(e)}function r(e){return n().cancelAnimationFrame(e)}export{r as cancelAnimFrame,e as requestAnimFrame};
//# sourceMappingURL=AnimationFrameProvider.min.mjs.map
